import { axiosInstance } from "../../../Services";

export const fetchAllBoards = async () => {
  try {
    const res = await axiosInstance.get("/mmhboard/boards", {
    });
    return res.data; // assuming your axiosInstance returns res.data by default
  } catch (error) {
    console.error("fetchAllBoards failed:", error);
    throw error;
  }
};

export const fetchAllGroups = async () => {
  try {
    const res = await axiosInstance.get("/mmhboard/groups", {
    });
    return res.data;
  } catch (error) {
    console.error("fetchAllGroups failed:", error);
    throw error;
  }
};

export const fetchGroupDetails = async (groupCode) => {
  try {
    const res = await axiosInstance.get(`/mmhboard/groups/${groupCode}`, {
    });
    return res.data;
  } catch (error) {
    console.error("fetchGroupDetails failed:", error);
    throw error;
  }
};

export const createGroup = async (name, memberIds) => {
  try {
    const formData = new FormData();
    formData.append('name', name.trim());
    memberIds.forEach(id => formData.append('members[]', id));

    const res = await axiosInstance.post("/mmhboard/groups", formData, {
    });
    return res.data;
  } catch (error) {
    console.error("createGroup failed:", error);
    throw error;
  }
};

export const deleteGroup = async (groupId) => {
  try {
    const res = await axiosInstance.delete(`/mmhboard/groups/${groupId}`, {
    });
    return res.data;
  } catch (error) {
    console.error("deleteGroup failed:", error);
    throw error;
  }
};

export const assignBoardToGroup = async (groupCode, boardId) => {
  try {
    const formData = new FormData();
    formData.append('group_code', groupCode);
    formData.append('board_id', boardId);

    const res = await axiosInstance.post("/mmhboard/groups/assignBoard", formData, {
    });
    return res.data;
  } catch (error) {
    console.error("assignBoardToGroup failed:", error);
    throw error;
  }
};

export const updateGroupMember = async (memberId, payload) => {
  // payload = { group_code, is_manager, old_card_limit, new_card_limit }
  try {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const res = await axiosInstance.post(
      `/mmhboard/groups/member/${memberId}/update`,
      formData,
    );
    return res.data;
  } catch (error) {
    console.error("updateGroupMember failed:", error);
    throw error;
  }
};